import React from 'react';
import {
  Delete,
  Watch,
  Exclude,
  ToCRM,
  Return,
  BlockAuthor,
  MuteAuthor,
  UnmuteAuthor
} from '../Actions';
import ToPendingExclusion from '../Actions/ToPendingExclusion';
import ToPodiumTitle from '../Actions/ToPodiumTitle';
import ToContacted from '../Actions/ToContacted';

import {
  ALL_NEW_TITLE,
  HOT_TITLES,
  MANUALLY_ADDED,
  PODIUM_TITLES,
  WATCHLIST,
  ALL_TITLES_RR,
  POPULAR,
  WATCHLIST_RR,
  TRENDING,
  RISING_STARS,
  SENT_TO_CRM_RR,
  SEND_TO_CRM,
  ALL_EXCLUDED_RR,
  ALL_EXCLUDED,
  COMPETITORS,
  PODIUM_TITLES_RR,
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR
} from '../../core/constants';

import { useUserPermit } from '../../context/User.context';

interface IOverlayActionProps {
  book: any;
  TAB_ID: string;
  refetchTable?: Function;
}

// Config
const PODIUM_DISABLED_TABS = new Set([
  PODIUM_TITLES,
  PODIUM_TITLES_RR,
  POPULAR,
  RISING_STARS,
  TRENDING
]);

const RETURN_DISABLED_TABS = new Set([
  ALL_NEW_TITLE,
  ALL_TITLES_RR,
  MANUALLY_ADDED,
  HOT_TITLES,
  POPULAR,
  RISING_STARS,
  TRENDING,
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR
]);

const PENDING_EXCLUSION_TABS = new Set([
  ALL_NEW_TITLE,
  HOT_TITLES,
  MANUALLY_ADDED,
  ALL_TITLES_RR
]);

const EXCLUDE_DISABLED_TABS = new Set([
  ALL_EXCLUDED_RR,
  ALL_EXCLUDED,
  ALL_NEW_TITLE,
  HOT_TITLES,
  ALL_TITLES_RR,
  MANUALLY_ADDED,
  PODIUM_TITLES,
  PODIUM_TITLES_RR,
  COMPETITORS
]);

const CONTACTED_TABS = new Set([
  ALL_NEW_TITLE,
  ALL_TITLES_RR,
  WATCHLIST,
  WATCHLIST_RR,
  HOT_TITLES,
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR
]);

const CRM_DISABLED_TABS = new Set([
  SEND_TO_CRM,
  SENT_TO_CRM_RR
]);

const MUTE_AUTHOR_ENABLED_TABS = new Set([
  ALL_NEW_TITLE,
  ALL_TITLES_RR
]);

const UNMUTE_AUTHOR_TABS = new Set([
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR
]);


// Component
const OverlayActions: React.FC<IOverlayActionProps> = ({
  book,
  TAB_ID
}) => {
  const { edit_titles, move_titles_hubspot } = useUserPermit();
  const showPodium = !PODIUM_DISABLED_TABS.has(TAB_ID);
  const showReturn = !RETURN_DISABLED_TABS.has(TAB_ID);
  const showPendingExclusion = PENDING_EXCLUSION_TABS.has(TAB_ID);
  const showExclude = !EXCLUDE_DISABLED_TABS.has(TAB_ID);
  const showContacted = CONTACTED_TABS.has(TAB_ID);
  const showCRM = move_titles_hubspot && !CRM_DISABLED_TABS.has(TAB_ID);
  const showWatch = TAB_ID !== WATCHLIST && TAB_ID !== WATCHLIST_RR;
  const showMuteAuthor = MUTE_AUTHOR_ENABLED_TABS.has(TAB_ID);
  const showUnmuteAuthor = UNMUTE_AUTHOR_TABS.has(TAB_ID);

  if (!edit_titles) {
    return null;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'end' }}>
      <div className='overlay-actions'>
        {showWatch && (<Watch book={book} id={TAB_ID} />)}
        {showPodium && (<ToPodiumTitle book={book} id={TAB_ID} />)}
        {showContacted && (<ToContacted book={book} id={TAB_ID} />)}
        {showCRM && <ToCRM book={book} id={TAB_ID} />}
        {showPendingExclusion && (<ToPendingExclusion book={book} id={TAB_ID} />)}
        {showUnmuteAuthor && <UnmuteAuthor book={book} id={TAB_ID} />}
        {showExclude && <Exclude book={book} id={TAB_ID} />}
        {showReturn && <Return book={book} id={TAB_ID} />}
        {showMuteAuthor && <MuteAuthor book={book} id={TAB_ID} />}
        <BlockAuthor book={book} id={TAB_ID} />
        <Delete book={book} id={TAB_ID} />
      </div>
    </div>
  );
};

export default OverlayActions;